/**
 * Apricot Daily landing — one-time or selling-plan add to cart + offer gallery.
 */
(function () {
  'use strict';
  if (window.__rncAdCartInit) return;
  window.__rncAdCartInit = true;

  function initGallery(root) {
    if (!root || root.__adGalleryReady) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ad-gallery-thumb]'));
    if (thumbs.length < 2) return;
    root.__adGalleryReady = true;

    var stage = root.querySelector('[data-ad-gallery-stage]');
    var thumbsWrap = root.querySelector('[data-ad-gallery-thumbs]');
    var prevBtn = root.querySelector('[data-ad-gallery-prev]');
    var nextBtn = root.querySelector('[data-ad-gallery-next]');
    var index = 0;

    if (thumbsWrap) thumbsWrap.hidden = false;
    if (prevBtn) prevBtn.hidden = false;
    if (nextBtn) nextBtn.hidden = false;

    function show(i) {
      if (!thumbs.length || !stage) return;
      index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      var src = t.getAttribute('data-src') || '';
      var srcset = t.getAttribute('data-srcset') || '';
      var alt = t.getAttribute('data-alt') || '';
      if (src) stage.src = src;
      if (srcset) {
        stage.srcset = srcset;
      } else {
        stage.removeAttribute('srcset');
      }
      if (alt) stage.alt = alt;
      thumbs.forEach(function (btn, idx) {
        var on = idx === index;
        btn.classList.toggle('is-active', on);
        if (on) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(parseInt(btn.getAttribute('data-index') || '0', 10));
      });
    });
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        show(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        show(index + 1);
      });
    }

    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        show(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        show(index + 1);
      }
    });

    // Light swipe for mobile
    var startX = null;
    root.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        if (startX == null || !e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        if (dx > 0) show(index - 1);
        else show(index + 1);
      },
      { passive: true }
    );
  }

  document.querySelectorAll('[data-ad-gallery]').forEach(initGallery);

  function openDrawer() {
    var api = window.RNC_BUNDLE_GIFTS;
    if (api && typeof api.openCartDrawer === 'function') {
      api.openCartDrawer();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    var openers = document.querySelectorAll(
      '[data-cart-toggle], .js-drawer-open-cart, [href="/cart"], .cart-link'
    );
    if (openers.length) {
      try {
        openers[0].click();
      } catch (e) {}
    }
  }

  function addToCart(variantId, sellingPlanId) {
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [item] }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error((data && (data.description || data.message)) || 'Could not add to cart');
        }
        return data;
      });
    });
  }

  function selectedPlan(root, btn) {
    if (!root) return { mode: 'onetime', planId: '' };
    if (btn) {
      var force = btn.getAttribute('data-force-mode');
      if (force === 'sub' || force === 'onetime') {
        return {
          mode: force,
          planId:
            btn.getAttribute('data-selling-plan-id') ||
            root.getAttribute('data-selling-plan-id') ||
            '',
        };
      }
    }
    if (root.getAttribute('data-purchase-layout') === 'subscribe-first') {
      return {
        mode: 'sub',
        planId: root.getAttribute('data-selling-plan-id') || '',
      };
    }
    var checked = root.querySelector('input[name="rnc-ad-purchase"]:checked');
    if (!checked) return { mode: 'onetime', planId: '' };
    return {
      mode: checked.value === 'sub' ? 'sub' : 'onetime',
      planId: checked.getAttribute('data-selling-plan-id') || '',
    };
  }

  function updatePriceLabels(root) {
    if (!root) return;
    var sel = selectedPlan(root);
    var priceEl = root.querySelector('[data-ad-price]');
    var compareEl = root.querySelector('[data-ad-compare]');
    var cta = root.querySelector('[data-ad-atc]:not([data-force-mode="onetime"])');
    var subPrice = root.getAttribute('data-sub-price') || '';
    var onePrice = root.getAttribute('data-one-price') || '';
    var compare = root.getAttribute('data-compare-price') || '';
    var subscribeFirst = root.getAttribute('data-purchase-layout') === 'subscribe-first';
    if (priceEl) {
      priceEl.textContent = sel.mode === 'sub' && subPrice ? subPrice : onePrice;
    }
    if (compareEl) {
      if (sel.mode === 'sub' && onePrice) {
        compareEl.textContent = onePrice;
        compareEl.hidden = false;
      } else if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (cta && !subscribeFirst) {
      var oneLabel = cta.getAttribute('data-label-onetime') || 'Add to cart';
      var subLabel = cta.getAttribute('data-label-sub') || 'Subscribe & Save';
      if (!cta.disabled || cta.textContent.indexOf('Adding') === -1) {
        cta.textContent = sel.mode === 'sub' ? subLabel : oneLabel;
      }
    }
    root.querySelectorAll('.rnc-ad-offer__opt').forEach(function (lab) {
      var input = lab.querySelector('input');
      lab.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[name="rnc-ad-purchase"]')) return;
    var root = e.target.closest('[data-ad-product]');
    updatePriceLabels(root);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ad-atc]');
    if (!btn) return;
    e.preventDefault();
    var root = btn.closest('[data-ad-product]') || document.querySelector('[data-ad-product]');
    var variantId = (root && root.getAttribute('data-variant-id')) || btn.getAttribute('data-variant-id') || '';
    var handle = (root && root.getAttribute('data-handle')) || 'apricot-daily-30-day-challenge-pack';
    if (!variantId) {
      window.location.href = '/products/' + handle;
      return;
    }
    var sel = selectedPlan(root, btn);
    var planId = sel.mode === 'sub' ? sel.planId : '';
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    addToCart(variantId, planId)
      .then(function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'apricot_daily_atc',
            placement: btn.getAttribute('data-ad-atc'),
            purchase_mode: sel.mode,
          });
        } catch (err) {}
        btn.textContent = 'Added ✓';
        openDrawer();
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
          updatePriceLabels(root);
        }, 2200);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = orig;
          updatePriceLabels(root);
        }, 2000);
      });
  });

  document.querySelectorAll('[data-ad-product]').forEach(updatePriceLabels);
})();
